export default [
  {
    label: 'Standard',
    value: 'general',
  },
  {
    label: 'Executive',
    value: 'executive',
  },
  {
    label: 'Webinar',
    value: 'webinar',
  },
  {
    label: 'Group Coaching',
    value: 'group_coaching',
  },
  {
    label: 'Pro Bono',
    value: 'pro_bono',
  },
];
